import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import CurrFixedDepositListPageUI from './CurrFixedDepositListPageUI.js'

class CurrFixedDepositListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      fdTransferList: null,
      fdTransactions: null,
      financialYear: '',
      financialYearList: []
    }
  }

  render() {
    return (
      <CurrFixedDepositListPageUI
        context={this.props.context}
        accountNumber={this.props.match.params.accountNumber}
        fdTransferList={this.state.fdTransferList}
        fdTransactions={this.state.fdTransactions}
        fdTxnList={this.state.fdTxnList}
        totals={this.state.totals}
        fdMonthlyTotals={this.state.fdMonthlyTotals}
        onRefreshClick={this.onRefreshClick}
        //
        financialYear={this.state.financialYear}
        financialYearList={this.state.financialYearList}
        onFinancialYearChange={this.onFinancialYearChange}
      />
    )
  }

  onFinancialYearChange = (option) => {
    let context = this.props.context
    this.setState({ financialYear: option.value })
    this.getFixedDeposits(context, this.props.match.params.accountNumber, option.value)
    this.getFDTxns(context, this.props.match.params.accountNumber)
  }

  componentDidMount() {
    let context = this.props.context
    this.getYears(context)
    this.getBankTxns(context, this.props.match.params.accountNumber)
  }

  getYears(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/years`,
      cacheKey: CacheKeys.Years(),
      callback: this.getYearsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getYearsCallback = (response) => {
    let financialYearList = response.financialYearList.map((years) => {
      return { value: years, label: years }
    })
    this.setState(
      { errorList: response.errorList, financialYearList: financialYearList },
      () => {
        let currentFinancialYear = response.currentFinancialYear
        this.getFixedDeposits(this.props.context, this.props.match.params.accountNumber, currentFinancialYear)
      }
    )
  }

  getBankTxns(context, accountNumber) {
    let cacheManager = new CacheManager({
      resource: `/api/su/nodalBankAccounts/${accountNumber}/bankTransactions/external`,
      cacheKey: CacheKeys.ExternalTxns(accountNumber),
      callback: this.getBankTxnsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getBankTxnsCallback = (response) => {
    this.setState({
      fdTransferList: response.fdTransferList,
      totals: response
    })
  }

  getFDTxns(context, accountNumber) {
    let cacheManager = new CacheManager({
      resource: `/api/su/nodalBankAccounts/${accountNumber}/bankTransactions/fixedDeposits`,
      cacheKey: CacheKeys.FDTxns(accountNumber),
      callback: this.getFDTxnsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getFDTxnsCallback = (response) => {
    this.setState({
      fdTxnList: response.transactionList,
    })
  }

  getFixedDeposits(context, accountNumber, financialYear) {
    let cacheManager = new CacheManager({
      resource: `/api/su/nodalBankAccounts/${accountNumber}/fixedDeposits`,
      cacheKey: CacheKeys.FixedDeposits(accountNumber, financialYear),
      callback: this.getFixedDepositsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context, null, {
      financialYear: financialYear
    })
  }

  getFixedDepositsCallback = (response) => {
    this.setState({
      fdTransactions: response.fdTransactions,
      fdMonthlyTotals: response,
      financialYear: response.financialYear
    })
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Years())
    CacheManager.removeObject(CacheKeys.FDTxns(this.props.match.params.accountNumber))
    CacheManager.removeObject(CacheKeys.ExternalTxns(this.props.match.params.accountNumber))
    CacheManager.removeObject(CacheKeys.FixedDeposits(this.props.match.params.accountNumber, this.state.financialYear))
    this.setState({ totals: null, fdTransactions: null }, () => {
      this.getYears(context)
      this.getFDTxns(context, this.props.match.params.accountNumber)
      this.getBankTxns(context, this.props.match.params.accountNumber)
      this.getFixedDeposits(context, this.props.match.params.accountNumber, this.state.financialYear)
    })
  }
}

export default withRouter(CurrFixedDepositListPageSF)
